var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"block p-3 flex-1"},[_c('loader-content',[(_vm.grid)?[_c('loader-grid')]:[_c('loader-heading'),_c('loader-text',{attrs:{"lines":4}})]],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }